export const queryBuilder = (query) => {
    const params = new URLSearchParams();

    if ('include' in query) {
        const includeValue = query.include;
        if (includeValue !== undefined && includeValue !== null && includeValue !== '') {
            if (Array.isArray(includeValue)) {
                params.append('include', includeValue.join(','));
            } else {
                params.append('include', includeValue.toString());
            }
        }
    }

    Object.entries(query).forEach(([key, value]) => {
        if (key === 'include') return;
        if (value === undefined || value === null || value === '') return;

        if (typeof value === 'object' && !Array.isArray(value)) {
            Object.entries(value).forEach(([subKey, subVal]) => {
                if (subVal === undefined || subVal === null || subVal === '') return;

                if (Array.isArray(subVal)) {
                    subVal.forEach(item => {
                        params.append(`${key}[${subKey}][]`, item.toString());
                    });
                } else {
                    params.append(`${key}[${subKey}]`, subVal.toString());
                }
            });
        } else if (Array.isArray(value)) {
            value.forEach(v => {
                params.append(`${key}`, v.toString());
            });
        } else {
            params.append(key, value.toString());
        }
    });

    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
};
